module.exports = __webpack_public_path__ + "img/issue-icon14.23616be.png";